import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-sandglass-icon]',
  template: `
    <svg:path
      d="M0 2C0 0.89543 0.895431 0 2 0H14C15.1046 0 16 0.89543 16 2V5.23253C16 5.97365 15.7257 6.68855 15.2299 7.23942L11.8454 11L15.2299 14.7606C15.7257 15.3115 16 16.0263 16 16.7675V20C16 21.1046 15.1046 22 14 22H2C0.895431 22 0 21.1046 0 20V16.7675C0 16.0263 0.274331 15.3115 0.770118 14.7606L4.15464 11L4.89793 11.669L4.15464 11L0.770118 7.23942C0.274332 6.68855 0 5.97365 0 5.23253V2ZM14 2H2V5.23253C2 5.47957 2.09144 5.71787 2.25671 5.90149L5.64123 9.66207C6.32578 10.4227 6.32577 11.5773 5.64123 12.3379L2.25671 16.0985C2.09144 16.2821 2 16.5204 2 16.7675V20H14V16.7675C14 16.5204 13.9086 16.2821 13.7433 16.0985L10.3588 12.3379C9.67422 11.5773 9.67423 10.4227 10.3588 9.66207L13.7433 5.90149C13.9086 5.71787 14 5.47957 14 5.23253V2Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SandglassIcon {
  readonly viewBox = input<string>('0 0 16 22');
}
